import * as constants from './constants'

export const addPaymentMethodSuccess = () => ({
    type: constants.ADD_PAYMENT_METHOD_SUCCESS,
})

export const setDefaultCreditCard = creditCard => ({
    type: constants.SET_DEFAULT_CREDIT_CARD,
    creditCard,
})

export const removeCreditCard = creditCard => ({
    type: constants.REMOVE_CREDIT_CARD,
    creditCard,
})

export const initPayment = (card, paymentTotal, locationId, orderId) => ({
    type: constants.INIT_PAYMENT,
    card,
    paymentTotal,
    locationId,
    orderId,
})

export const pspVerificationResponse = (details, errors) => ({
    type: constants.PSP_VERIFICATION_RESPONSE,
    details,
    errors,
})

export const secure3dResponse = (details, errors) => ({
    type: constants.SECURE3D_RESPONSE,
    details,
    errors,
})

export const cancelSecure3d = () => ({
    type: constants.SECURE3D_CANCELLED,
})
